import { ExtraModel, IEducation, IExperience, IExtra, ILanguage, IQualification, ISkill } from "@core/models";

export const candidateAEProfileMock = new ExtraModel({
  [IExtra.address]: "12 rue du puit1",
  [IExtra.birthDate]: "1980-02-15T00:00:00+01:00",
  [IExtra.city]: "Paris1",
  [IExtra.motivationText]:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla cursus neque ac nibh accumsan, lacinia convallis tellus tristique. Suspendisse posuere sem eu diam rutrum rutrum. Curabitur ac cursus augue, nec sollicitudin sapien. Sed vulputate et lorem quis volutpat. Aliquam erat volutpat. Cras in tincidunt nunc. Integer iaculis lorem eget pulvinar lobortis. Integer non varius eros.",
  [IExtra.education]: [
    {
      [IEducation.label]: "CAP Arts du service en restauration",
      [IEducation.detail]: "CFA Saint-Paul-Les-Rombières-du-Poitou",
      [IEducation.date]: "2012",
    },
    {
      [IEducation.label]: "BTS Management en hôtellerie restauration",
      [IEducation.detail]: "Maison familiale rurale des Baronnies",
      [IEducation.date]: "2014",
    },
  ],

  [IExtra.experiences]: [
    {
      [IExperience.qualification]: { [IQualification.qualificationLabel]: "Chef de rang" },
      [IExperience.etabName]: "Paradis du Fruit - Saint Michel",
      [IExperience.etabType]: "Restaurant",
      [IExperience.note]: 5,
      [IExperience.start]: "2016-10-30T00:00:00+01:00",
      [IExperience.end]: "2016-10-31T00:00:00+01:00",
      [IExperience.comment]:
        "Sérieux, sympathique et dynamique. \r\nIl a rapidement évolué de serveur à chef de rang.\r\n4 ans au total dans différents Paradis du Fruit (Wagram et Les Halles).",
      [IExperience.contract]: "cdi",
    },
    {
      [IExperience.qualification]: { [IQualification.qualificationLabel]: "Serveur" },
      [IExperience.etabName]: "Le Perchoir - Restaurant",
      [IExperience.etabType]: "Restaurant français",
      [IExperience.note]: 5,
      [IExperience.start]: "2015-10-30T00:00:00+01:00",
      [IExperience.end]: "2015-10-31T00:00:00+01:00",
      [IExperience.comment]: "Gros succès auprès de du staff et auprès des clients. Dynamique, réactif, serviable, polie et professionnel.",
      [IExperience.contract]: "extra",
    },
  ],

  [IExtra.firstname]: "Benjamin",
  [IExtra.lastname]: "de la Teste",
  [IExtra.phone]: "01 02 03 04 05",
  [IExtra.email]: "benjamin.delateste@test.com",
  [IExtra.languages]: [
    { [ILanguage.label]: "Français" },
    { [ILanguage.label]: "Anglais" },
    { [ILanguage.label]: "Arabe", [ILanguage.level]: "Intermédiaire" },
  ],
  [IExtra.photo]: "https://picsum.photos/id/1005/600/600",
  [IExtra.postalCode]: "91441",
  [IExtra.presentation]: "Ponctuel, à l'écoute, autonome, organisé et souriant je m'intègre facilement dans un groupe.",
  [IExtra.qualificationsOnExperiences]: ["Chef de partie", "Chef de cuisine", "Runner", "Chef de rang", "Serveur"],
  [IExtra.skills]: [{ [ISkill.label]: "Service au plateau" }, { [ISkill.label]: "Gestion d'équipe" }, { [ISkill.label]: "Maîtrise de caisse Pi" }],
  [IExtra.statusCandidate]: "selected",
  [IExtra.vehicle]: 1,
});
